import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "./AdminModals.scss";

export const adminSwal = Swal.mixin({
  buttonsStyling: false,
  focusConfirm: false,
  scrollbarPadding: false,
  customClass: {
    container: "admin-swal-container",
    popup: "admin-swal-popup",
    title: "admin-swal-title",
    htmlContainer: "admin-swal-html",
    input: "admin-swal-input",
    actions: "admin-swal-actions",
    confirmButton: "admin-swal-confirm",
    cancelButton: "admin-swal-cancel",
    denyButton: "admin-swal-deny",
    validationMessage: "admin-swal-validation",
    icon: "admin-swal-icon",
  },
});
